import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { ClassificatorField, DateRangeField, NumberField } from '../../atoms';
import { FormActions, AutoCompleteAccountsField } from '../../components';
import { connect } from 'react-redux';
import { FORM_TRANSACTION_SEARCH } from '../../constants/formKeys';
import { formTransactionSearchFields } from '../../constants/forms/formTransactionSearch';
import { Collapse, Row, Col, Button } from 'antd';
import * as actions from '../../actions/actionCreators/transactionSearchActionCreators';
import { gas } from '../../constants/classificators';
import { legalEntityFields } from '../../constants/legalEntity';
import { getBasicFilterDateRanges } from '../../utils/dates';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import RffFields from '../../atoms/rff/RffFields';

const { Panel } = Collapse;

export class TransactionFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    searchTransactions: PropTypes.func.isRequired,
    accountId: PropTypes.string,
    gasFieldValue: PropTypes.string,
    initialValues: PropTypes.object,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { initialValues, updateFormState, searchTransactions } = this.props;
    this._initialValues = initialValues;
    if (initialValues) {
      updateFormState(FORM_TRANSACTION_SEARCH, { values: initialValues });
    }
    searchTransactions();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.accountId !== prevProps.accountId) {
      this._initialValues = this.props.initialValues;
      if (this._form) {
        this._form.restart(this._initialValues);
      }
      this.props.updateFormState(FORM_TRANSACTION_SEARCH, {
        values: this._initialValues,
      });
      this.props.searchTransactions();
    }
  }

  onClear = (form) => {
    form.restart(this._initialValues);
    this.props.updateFormState(FORM_TRANSACTION_SEARCH, {
      values: this._initialValues,
    });
    this.props.searchTransactions();
  };

  onSubmit = () => {
    this.props.searchTransactions();
  };

  render() {
    const { t, gasFieldValue } = this.props;
    NumberField.defaultProps.precision = 0;
    return (
      <div>
        <div className="search-form-container">
          <Collapse defaultActiveKey={['filters']}>
            <Panel key="filters" header={t('filter.panelTitle')}>
              <Form
                initialValues={this._initialValues}
                onSubmit={this.onSubmit}
                render={({ handleSubmit, form }) => {
                  this._form = form;
                  return (
                    <form onSubmit={handleSubmit}>
                      <FormStateToRedux form={FORM_TRANSACTION_SEARCH} />
                      <Row gutter={32}>
                        <Col span={16}>
                          <RffFields
                            label={t('filter.dateRange.title')}
                            names={[
                              formTransactionSearchFields.DATE_FROM,
                              formTransactionSearchFields.DATE_TO,
                            ]}
                            placeholder={[
                              t('filter.dateRange.dateFromPlaceholder'),
                              t('filter.dateRange.dateToPlaceholder'),
                            ]}
                            style={{ width: '100%' }}
                            component={DateRangeField}
                            hasFeedback={false}
                            allowClear={false}
                            ranges={getBasicFilterDateRanges(t)}
                          />
                        </Col>
                        <Col span={8}>
                          <Field
                            label={t('filter.transactionType')}
                            name={formTransactionSearchFields.TRANSACTION_TYPE}
                            component={ClassificatorField}
                            classificatorType={
                              ClassificatorField.types.transactionType
                            }
                            hasFeedback={false}
                          />
                        </Col>
                      </Row>
                      <Row gutter={32}>
                        <Col span={8}>
                          <Field
                            label={t('filter.receiverAccount')}
                            name={
                              formTransactionSearchFields.RECEIVER_ACCOUNT_NUMBER
                            }
                            component={AutoCompleteAccountsField}
                            hasFeedback={false}
                          />
                        </Col>
                        <Col span={8}>
                          <Field
                            label={t('filter.senderAccount')}
                            name={
                              formTransactionSearchFields.SENDER_ACCOUNT_NUMBER
                            }
                            component={AutoCompleteAccountsField}
                            hasFeedback={false}
                          />
                        </Col>
                        <Col span={8}>
                          <Field
                            label={t('filter.number')}
                            name={formTransactionSearchFields.NUMBER}
                            component={NumberField}
                            hasFeedback={false}
                          />
                        </Col>
                      </Row>
                      <Row gutter={32}>
                        <Col span={8}>
                          <Field
                            label={t('filter.gas')}
                            name={formTransactionSearchFields.GAS}
                            component={ClassificatorField}
                            classificatorType={ClassificatorField.types.gas}
                            hasFeedback={false}
                          />
                        </Col>
                        {gasFieldValue === gas.BIOMETHANE && (
                          <>
                            <Col span={8}>
                              <Field
                                label={t('filter.fuelType')}
                                name={formTransactionSearchFields.FUEL_TYPE}
                                component={ClassificatorField}
                                classificatorType={
                                  ClassificatorField.types.fuelType
                                }
                                hasFeedback={false}
                              />
                            </Col>
                            <Col span={8}>
                              <Field
                                label={t('filter.cleaningTechnologyType')}
                                name={
                                  formTransactionSearchFields.CLEANING_TECHNOLOGY_TYPE
                                }
                                component={ClassificatorField}
                                classificatorType={
                                  ClassificatorField.types
                                    .cleaningTechnologyType
                                }
                                hasFeedback={false}
                              />
                            </Col>
                          </>
                        )}
                        {gasFieldValue === gas.HYDROGEN && (
                          <>
                            <Col span={8}>
                              <Field
                                label={t('filter.hydrogenType')}
                                name={formTransactionSearchFields.HYDROGEN_TYPE}
                                component={ClassificatorField}
                                classificatorType={
                                  ClassificatorField.types.hydrogenType
                                }
                                hasFeedback={false}
                              />
                            </Col>
                            <Col span={8}>
                              <Field
                                label={t(
                                  'filter.hydrogenManufacturingTechnology'
                                )}
                                name={
                                  formTransactionSearchFields.HYDROGEN_MANUFACTURING_TECHNOLOGY
                                }
                                component={ClassificatorField}
                                classificatorType={
                                  ClassificatorField.types
                                    .hydrogenTechnologyType
                                }
                                hasFeedback={false}
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                      <FormActions>
                        <Button onClick={() => this.onClear(form)}>
                          {t('filter.clearBtn')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                          {t('filter.submitBtn')}
                        </Button>
                      </FormActions>
                    </form>
                  );
                }}
              />
            </Panel>
          </Collapse>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector(FORM_TRANSACTION_SEARCH);

function determineGasTypeAndAccountIds(ownProps) {
  let gasValue = null;
  let producerIds = null;
  const legalEntity = ownProps.legalEntity;
  if (legalEntity) {
    if (ownProps.accountId === 'manufacture') {
      const manufacturerAccountTypes = [
        'MANUFACTURER',
        'HYDROGEN_MANUFACTURER',
      ];
      producerIds = legalEntity
        .get('accounts')
        .filter((account) =>
          manufacturerAccountTypes.includes(account.get('accountType'))
        )
        .map((account) => account.get('id'));
    } else {
      producerIds = [ownProps.accountId];
    }
    const isHydrogenManufacturer = legalEntity.get(
      legalEntityFields.HYDROGEN_MANUFACTURER
    );
    const isBiomethaneManufacturer = legalEntity.get(
      legalEntityFields.MANUFACTURER
    );
    const isTrader = legalEntity
      .get('accounts')
      .some(
        (account) =>
          producerIds.includes(account.get('id') + '') &&
          account.get('accountType') === 'TRADER'
      );
    if (!isTrader) {
      if (isHydrogenManufacturer && !isBiomethaneManufacturer) {
        gasValue = gas.HYDROGEN;
      } else if (!isHydrogenManufacturer && isBiomethaneManufacturer) {
        gasValue = gas.BIOMETHANE;
      }
    }
  }
  return { producerIds, gasValue };
}

const mapStateToProps = (state, ownProps) => {
  const values = determineGasTypeAndAccountIds(ownProps);
  const producerIds = values.producerIds;
  const gasValue = values.gasValue;
  return {
    initialValues: {
      ...(producerIds != null && {
        [formTransactionSearchFields.CURRENT_ACCOUNT_ID]: producerIds,
      }),
      ...(gasValue != null && {
        [formTransactionSearchFields.GAS]: gasValue,
      }),
    },
    gasFieldValue: selector(state, formTransactionSearchFields.GAS),
  };
};

const mapDispatchToProps = {
  ...actions,
  updateFormState,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionFilter);
